import React, { Component } from 'react'
import { Card, Icon, Input } from "antd"
import CommitBlock from "./CommitBlock"
import BlockSummaryBar from "./BlockSummaryBar"
import { batchesNotPushStatics } from "../../../../services/api/3dApi"
import { sortBlocksByFixedOrder, buildCommitAllBlock, COMMIT_ALL_KEY, formatNumber } from "./blockConfig"

const DEBOUNCE_MS = 500
const AUTO_COLLAPSE_THRESHOLD = 50

class SkuNotBatches extends Component {
    state = {
        loading: false,
        error: '',
        blocks: [],
        total_all: '-',
        skuFilter: '',
        overdueOnly: false,
        openBlocks: {},
        openBlocksInitialized: false,
    }

    componentDidMount() {
        this._fetchStaticsCreated()
    }

    componentWillUnmount() {
        clearTimeout(this._debounceTimer)
    }

    _buildQuery = () => {
        const { skuFilter, overdueOnly } = this.state
        const params = []
        if (skuFilter) params.push(`sku=${encodeURIComponent(skuFilter)}`)
        if (overdueOnly) params.push(`overdueOnly=true`)
        return params.join('&')
    }

    _fetchStaticsCreated = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const { data: response } = await batchesNotPushStatics(this._buildQuery())

            const { success, data, message } = response

            if (!success) {
                return this.setState({
                    loading: null,
                    error: message
                })
            }

            const blocks = data.blocks || []
            this.setState((prev) => ({
                loading: false,
                blocks,
                total_all: data.total_all,
                openBlocks: prev.openBlocksInitialized ? prev.openBlocks : this._buildDefaultOpenBlocks(blocks),
                openBlocksInitialized: true,
            }))
        } catch (e) {
            this.setState({
                loading: null,
                error: e.message
            })
        }
    }

    _onChangeSkuFilter = (e) => {
        const value = e.target.value
        clearTimeout(this._debounceTimer)
        this.setState({ skuFilter: value })
        this._debounceTimer = setTimeout(() => this._fetchStaticsCreated(), DEBOUNCE_MS)
    }

    _onToggleOverdueOnly = () => {
        this.setState(
            (prev) => ({ overdueOnly: !prev.overdueOnly }),
            () => this._fetchStaticsCreated()
        )
    }

    _buildDefaultOpenBlocks = (blocks) => {
        const orderedBlocks = sortBlocksByFixedOrder(blocks)
        const totalSkuRows = orderedBlocks.reduce((sum, b) => sum + (b.skuCount || 0), 0)
        const openBlocks = {}
        orderedBlocks.forEach((block) => {
            openBlocks[block.block] = totalSkuRows > AUTO_COLLAPSE_THRESHOLD ? block.block === '1_day' : true
        })
        openBlocks[COMMIT_ALL_KEY] = true
        return openBlocks
    }

    _onToggleBlock = (blockKey, isOpen) => {
        this.setState((prev) => ({
            openBlocks: { ...prev.openBlocks, [blockKey]: isOpen }
        }))
    }

    _onExpandBlock = (blockKey) => {
        this.setState(
            (prev) => ({ openBlocks: { ...prev.openBlocks, [blockKey]: true } }),
            () => {
                setTimeout(() => {
                    const el = document.getElementById(`block-${blockKey}`)
                    if (el) el.scrollIntoView({ behavior: 'smooth' })
                }, 300)
            }
        )
    }

    render() {
        const { blocks, loading, error, total_all, skuFilter, overdueOnly, openBlocks } = this.state
        const orderedBlocks = sortBlocksByFixedOrder(blocks)
        const totalSkuRows = orderedBlocks.reduce((sum, b) => sum + (b.skuCount || 0), 0)
        const uniqueSkuCount = new Set(
            orderedBlocks.flatMap((b) => (b.items || []).map((item) => item.type))
        ).size
        const isFiltered = !!skuFilter || overdueOnly
        const isEmpty = !loading && orderedBlocks.length === 0
        const blocksToRender = isEmpty ? orderedBlocks : [...orderedBlocks, buildCommitAllBlock(orderedBlocks, total_all)]

        return (
            <div className='SkuNotBatches p-3'>
                <Card
                    className="m-3 ProductionProgress"
                    title="Thống kê số lượng SKU chưa phân lô"
                    extra={<Icon type="pie-chart" />}
                >
                    <div
                        className={`Total mb-3 ${!isEmpty ? 'TotalClickable' : ''}`}
                        onClick={!isEmpty ? () => this._onExpandBlock(COMMIT_ALL_KEY) : undefined}
                    >
                        Tổng số: <span>{formatNumber(total_all)}</span> {total_all > 1 ? 'items' : 'item'}
                    </div>

                    {!isEmpty && <BlockSummaryBar blocks={orderedBlocks} onExpandBlock={this._onExpandBlock} />}

                    <div className="FilterBar d-flex justify-content-start align-items-center mb-3">
                        <Input.Search
                            className="SkuFilterInput"
                            placeholder="Tìm theo mã SKU"
                            value={skuFilter}
                            onChange={this._onChangeSkuFilter}
                            allowClear
                        />
                        <div
                            className={`OverdueToggle ${overdueOnly ? 'active' : ''}`}
                            onClick={this._onToggleOverdueOnly}
                        >
                            Chỉ hiện dòng quá hạn
                        </div>
                        {!isEmpty && (
                            <div className="SkuRowCount ml-auto">
                                {formatNumber(uniqueSkuCount)}/{formatNumber(totalSkuRows)} dòng SKU · {formatNumber(orderedBlocks.length)} khối
                            </div>
                        )}
                    </div>

                    {error && <div className="text-danger">{error}</div>}

                    {isEmpty && !error && (
                        <div className="EmptyState text-center">
                            <b>Không có item nào chờ phân lô</b>
                            <div>Mọi item đã được phân vào lô. Bảng sẽ hiện lại khi có đơn mới từ FFM.</div>
                        </div>
                    )}

                    {blocksToRender.map((block) => (
                        <CommitBlock
                            key={block.block}
                            block={block}
                            isOpen={!!openBlocks[block.block]}
                            onToggle={this._onToggleBlock}
                            loading={loading}
                            isFiltered={isFiltered}
                        />
                    ))}

                    <div className="Legend">
                        <span className="Swatch" />
                        Dòng có item quá hạn phân lô
                    </div>
                </Card>
            </div>
        )
    }
}

export default SkuNotBatches
